import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableCellBase, type TableCellBaseProps } from "@core/ui";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = Omit<TableCellBaseProps, "data-testid">;

/**
 * Styled table cell wrapping TableCellBase.
 */
export const TableCell = forwardRef<HTMLTableCellElement, Props>(
  ({ children, className, ...props }, ref) => {
    return (
      <TableCellBase
        ref={ref}
        className={twMerge("p-2 align-middle md:p-4", className)}
        data-testid="table-cell"
        {...props}
      >
        <Type variant="caption" className="max-w-full">
          {children}
        </Type>
      </TableCellBase>
    );
  }
);

TableCell.displayName = "TableCell";

export default TableCell;

